export const Config = {
  main_url: 'https://slim.podarjuniors.com',
  mainpy_url: "https://python.podarjuniors.com",
};
